import {booleanAttribute, Component, computed, input, InputSignalWithTransform} from '@angular/core';
import {v4 as uuidv4}                                                           from 'uuid'
import {TableRow}                                    from '../../../../../comps/table/table-wrapper/table-wrapper.component';
import {MenuCrudPanelWrapperBase}                    from '../menu-crud-panel-wrapper-base';
import {MenuCrudTileComponent, PanelMenuConfRowIntf} from './menu-crud-tile/menu-crud-tile.component';


@Component({
			   selector   : 'app-menu-crud-panel-top',
			   imports: [
				   MenuCrudTileComponent
			   ],
			   templateUrl: './menu-crud-panel-top.component.html',
			   styleUrl   : './menu-crud-panel-top.component.css'
		   })


export class MenuCrudPanelTopComponent extends MenuCrudPanelWrapperBase {
	public rows = input<TableRow[]>();
	public conf = input<PanelMenuConfRowIntf[]>();
	public toggle = input(false, {transform: booleanAttribute})

	public gridConf = computed((): {
		uuid: string
	}[] => {
		const target = 24
		const currentConf = this.conf();
		const newItem = () => ({
			uuid: uuidv4()
		})
		if (!currentConf) return Array(target).fill(newItem());

		const delta = target - currentConf.length;

		// If conf().length === 8, return false
		if (delta <= 0) return [];

		// Otherwise, return an array of null[] with the delta size
		return Array(delta).fill(newItem());
	});


}
